import "./../../styles/dashboard.css";
import { ModernCategoryCard } from "../category/ModernCategoryGrid";

const TopUpSection = ({ title, packages }) => {
  const activePackages = packages?.filter((pack) => pack.product_status === "active");
  if (activePackages?.length <= 0) return null;

  return (
    <section className="account-section-container dashboard-topup-section">
      <div className="account-category">
        <div className="category-title-container">
          <h2 className="category-title">{title}</h2>
        </div>

        <div className="dashboard-product-grid mgc-grid mgc-grid--topup">
          {activePackages?.map((pack) => (
            <ModernCategoryCard key={pack._id} item={pack} type="topup" />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopUpSection;
